import { getClientStoredUserInfo, getUniversalUserInfo } from '@/utils/userCache';
import { useAuthStore } from '@/stores/auth';
import type { UserInfo } from '../../shared/type/UserInfo';

export function useUserInfo() {
	const authStore = useAuthStore();
	const userInfo = useState<UserInfo | null>('user-info', () => getUniversalUserInfo());

	const syncClientUserInfo = () => {
		if (!import.meta.client) return;

		if (!authStore.accessToken) {
			userInfo.value = null;
			return;
		}

		userInfo.value = getClientStoredUserInfo();
	};

	if (import.meta.client) {
		onMounted(() => {
			syncClientUserInfo();
		});

		watch(
			() => authStore.accessToken,
			() => {
				syncClientUserInfo();
			}
		);
	}

	return computed(() => userInfo.value);
}
